import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { EResponseBase } from '../data/base/ResponseBase';
import { LogDto } from '../data/logDto';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private http: HttpClient) { }
  
  saveLog(request: LogDto){
    return this.http.post<EResponseBase<LogDto>>(`${environment.url}/Log`, request);
  }

}
